// extracted by mini-css-extract-plugin
export default {"mainContainer":"Calculator_mainContainer__AZkd7","containerForm":"Calculator_containerForm__Wa8Fb","separator":"Calculator_separator__uOldY"};